import * as React from 'react';
import { ICSSProperties } from '../../../../entities/common';
import VisualControl from '../../base/VisualControl';
import { IDOMReadyEventArgs } from '../../entities/EventArgs';
import { IDOMElementProperties } from './entities/IDOMElementProperties';
import { FormItemTypes } from '@bimser/core';

export default class DOMElement extends VisualControl {
	_domElement: HTMLDivElement = null;
	_childElement: any = null;
	domStyle: ICSSProperties = {};

	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.DOMElement;
		this.__setRef = this.__setRef.bind(this);
		this.domStyle = {
			width: '100%',
			background: this.style.backgroundColor || '#fff'
		};
	}

	__endInitialize() {
		super.__endInitialize();
		this.__onRenderChild();
	}

	__loadProperties(data: IDOMElementProperties) {
		super.__loadProperties(data);
	}

	__setRef(domNode: HTMLDivElement) {
		this._domElement = domNode;
		const args: IDOMReadyEventArgs = { element: domNode };
		this.emit('event:OnDOMReady', args);
	}

	__onRenderChild(): any {
		this.emit('event:OnChildRender', {}).then(result => {
			this._childElement = result;
		});
	}

	__render(children?: React.ReactNode) {
		return super.__render(
			<>
				<div
					ref={this.__setRef}
					style={this.domStyle}
				>
					{this._childElement}
				</div>
			</>
		);
	}
}
